import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { yen } from './metrics';

export function expenseLines(row) {
  if (row.overrides?.includes('expenses')) return [
    `経費総額の手入力補正：${yen(row.expenses)}`,
    '補正総額を採用。固定費・電気代は追加加算しません。科目別内訳は未登録です。',
  ];
  const d = row.sources?.expenses?.details || {};
  const lines = [
    ['家賃', d.allocated_rent], ['通常給与の配分（交通費込み）', d.allocated_salary],
    ['マンスリー人件費', d.monthly_labor], ['決済手数料等', d.stripe_fees],
    ['Stripeその他費用', d.stripe_other_costs],
  ].map(([label, value]) => `${label}：${value == null ? '未取得・未確定' : yen(value)}`);
  if (d.fixed_cost_start) lines.push(`Wi-Fi：${yen(d.wifi)}`, `電気代：${d.electricity == null ? '未入力（小計に未加算）' : yen(d.electricity) + '（入力済み）'}`);
  if (d.rent_fixed_start) lines.push('家賃は2026年8月から月額250,000円に置換済み。既存家賃との重複加算なし。');
  lines.push(`登録経費小計：${yen(row.expenses)}`, '広告費は別枠。費目不明の手入力経費は除外。');
  return lines;
}

export default function ExpenseBreakdown({row}) {
  return <Tooltip arrow enterTouchDelay={0} leaveTouchDelay={5000}
    title={<div>{expenseLines(row).map((line, i) => <div key={i}>{line}</div>)}</div>}>
    <button type="button" className="kz-expense-help" aria-label={`${row.month} 経費の計算内訳`}>ⓘ</button>
  </Tooltip>;
}
